import { Typography } from "@mui/material";
import { ViewCarousel as ViewCarouselIcon } from "@mui/icons-material"
import FormBuilderDesign from "components/InputsDesign/FormBuilderDesign";
import { DataFields } from "./DataFields";

export default function CarouselModule({ 
  t,
  dataInstance, 
  googleFonts, 
  register, 
  errors, 
  changeDataBoolean, 
  changeDataFunction, 
  setFieldImageManager, 
  openImageManager, 
  changeCompletePicker 
}) {

  return (<>
    <Typography variant="h6" sx={{ display: "flex", alignItems: "center" }}><ViewCarouselIcon /> &nbsp; {t('designmenu_select_option_navigation_menu')}</Typography>
    <FormBuilderDesign 
      dataDields={DataFields(t)}
      dataInstance={dataInstance}
      containerSelectOptions={{ googleFonts: googleFonts }}
      register={register}
      errors={errors}
      changeDataBoolean={changeDataBoolean}
      changeDataFunction={changeDataFunction}
      setFieldImageManager={setFieldImageManager}
      openImageManager={openImageManager}
      changeCompletePicker={changeCompletePicker}
    />
  </>)
}